import { render } from "./Introduction3.vue?vue&type=template&id=2ba7d2e8&scoped=true"
import script from "./Introduction3.vue?vue&type=script&lang=js"
export * from "./Introduction3.vue?vue&type=script&lang=js"

import "./Introduction3.vue?vue&type=style&index=0&id=2ba7d2e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ba7d2e8"

export default script